"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Grid_1 = require("@material-ui/core/Grid");
const TeaserItem_1 = require("@components/pages/home/TeaserItem");
const TeaserGallery = ({ items }) => (React.createElement(Grid_1.default, { container: true, spacing: 3 }, items.map((item, idX) => (React.createElement(Grid_1.default, { key: (item === null || item === void 0 ? void 0 : item.title) || idX.toString(), item: true, xs: 12, sm: 6, md: 6 },
    React.createElement(TeaserItem_1.default, Object.assign({}, item)))))));
exports.default = TeaserGallery;
